import { useEffect } from "preact/hooks";

const Home = () => {
  useEffect(() => {
    window.location.replace("https://mayahii.com/wallet");
  }, []);

  return null;
};

export default Home;